export default "__VITE_ASSET__26988f2b__"